module.exports = __webpack_public_path__ + "img/pic-lordsmobile.64dd1f8.png";